import { PluginHelper } from "./helpers/PluginHelper";
import { computeSizes } from "./helpers/computeSizes";
export function useLayoutGridItemComputedProps() {
    return (options) => computeLayoutGridItemComputedProps(options.cell);
}
function computeLayoutGridItemComputedProps(cell) {
    const sx = PluginHelper.getGridItemSxProps(cell);
    const className = `LayoutGrid-${cell.id} ${PluginHelper.getPluginClassName(cell)}`;
    const size = cell.size;
    const sizes = computeSizes(cell.size, cell.sizes);
    return {
        sx,
        size,
        sizes,
        className,
    };
}
//# sourceMappingURL=useLayoutGridItemComputedProps.js.map